import { Component, OnInit, Input, Output, EventEmitter,  TemplateRef, ViewChild } from '@angular/core';
import { IFileUpload } from '../../../shared/models/fileupload';
import { FileUploadService } from '../../../shared/providers/fileupload.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { OfferService } from '../../../shared/providers/offer.service';
import { RequestModel } from '../../../shared/models/RequestModel';
import { ResultOutputModel } from '../../../shared/models/resultOutputModel';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-offer-status-change',
  templateUrl: './offer-status-change.component.html',
})
export class OfferStatusChangeComponent implements OnInit {

    constructor(private _toastService: ToastService, private modalService: BsModalService, public router: Router, private authService: AuthenticationService, private _fileUploadService: FileUploadService, private _offerService: OfferService) {
    }
    @Input() modalRef: BsModalRef;
    @Input() showAccept: boolean;
    @Input() offerGuid: string;
    @Output() close = new EventEmitter();
    @Output() acceptedOffer = new EventEmitter();
  fileExtensionType: string = "document";
  @ViewChild('sendEmail') sendEmail: TemplateRef<any>;
  fileExtensionLOIType: string = "LOI";
  fileTypes = '.PDF';
  modalRefSendEmail: BsModalRef;
    fileUploadType: string = "single";
    clearFiles: number = 0;
    inputFileUploadForLOI = {} as IFileUpload;
    requestModel = {} as RequestModel;
    resultOutputModel = {} as ResultOutputModel;
    buyerOrSeller: string;
    options = [{ name: "Buyer", id: 1 }, { name: "Seller", id: 2 }];
    optionSelected: any;
    disabledAcceptBtn: boolean = false;
    disabledRejectBtn: boolean = false;
    selectedFiles: string[] = [];
    user: any;
    comments: string;
    IsExternalBroker = false;
    ngOnInit() {
        
        this.optionSelected = 0;
        this.user = this.authService.user;

        if (this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
            this.IsExternalBroker = true;
            this.optionSelected = 1;
        }
    }
    latestId = 0;
    openModalForCounterAccept(template: TemplateRef<any>, classes) {
        
        this.modalRef = this.modalService.show(template, { class: classes });
    }
    

  acceptOffer(sendEmail: boolean) {
        
        if (this.optionSelected != 0) {
            this.disabledAcceptBtn = true;
            this.requestModel.Guid = this.offerGuid;
            this.requestModel.StatusId = 460;
            this.requestModel.UserId = this.user.Id;
          this.requestModel.IsFromBuyer = this.optionSelected == 2 ? false : true;
          this.requestModel.SendEmail = sendEmail;
            this.buyerOrSeller = this.optionSelected == 2 ? "Seller" : "Buyer";
            this._offerService.acceptOrRejectOffer(this.requestModel).subscribe(response => {
                this.resultOutputModel = response;
                if (this.resultOutputModel.Success) {

                    this.latestId = this.resultOutputModel.Id;
                    this.inputFileUploadForLOI.documentName = "AcceptLOI_" + this.buyerOrSeller;
                    this.inputFileUploadForLOI.fileCategoryId = 413;
                    this.inputFileUploadForLOI.id = this.latestId;
                    this.inputFileUploadForLOI.objectId = this.latestId;
                    this.inputFileUploadForLOI.objectTypeId = 303;
                    this.inputFileUploadForLOI.type = "Documents";
                    this._fileUploadService.uploadFiles(this.inputFileUploadForLOI, this.selectedFiles).subscribe(response => {
                        this._toastService.addToast({ title: 'Success', msg: 'Offer Accepted Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
                        this.modalRef.hide();
                        this.disabledAcceptBtn = false;
                        //this.router.navigateByUrl("redirect?url=" + encodeURIComponent(this.router.url), { skipLocationChange: true });
                        this.acceptedOffer.emit();
                    });
                }
            });
        }
        else {
            this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select an option', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }

    }
    onClose() {
        this.modalRef.hide();
    }
    selectedFilesListEmitter(selectedFilesListEmitter: string[]) {
        this.selectedFiles = selectedFilesListEmitter;

    }

    rejectOffer() {
        
        if (this.optionSelected != 0) {
            this.requestModel.Guid = this.offerGuid;
            this.requestModel.StatusId = 457;
            this.requestModel.UserId = this.user.Id;
            this.requestModel.Comments = this.comments;
            this.requestModel.IsFromBuyer = this.optionSelected == 2 ? false : true;
            this.buyerOrSeller = this.optionSelected == 2 ? "Seller" : "Buyer";
            this.disabledRejectBtn = true;
            this._offerService.acceptOrRejectOffer(this.requestModel).subscribe(response => {
                this.resultOutputModel = response;
                if (this.resultOutputModel.Success) {
                    this._toastService.addToast({ title: 'Success', msg: 'Offer Rejected!', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
                    this.modalRef.hide();
                    this.router.navigateByUrl("redirect?url=" + encodeURIComponent(this.router.url), { skipLocationChange: true });
                }
            });
        }
        else {
            this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select an option', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }

  }

  sendEmailModal() {
    this.modalRefSendEmail = this.modalService.show(this.sendEmail, { class: 'deletemodal' });
  }
    openModalForCounterReject(template: TemplateRef<any>, classes) {
        this.modalRef = this.modalService.show(template, { class: classes });
    }
}
